module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (96).7655c339.jpg";